import React, { useState } from "react";

const questions = [
  {
    id: 1,
    text: "1. Vừa cày xong cái deadline sấp mặt, bạn thấy đã nhất khi:",
    options: {
      A: "Sếp nhắn tin Zalo khen: 'Job này em làm đỉnh quá!'",
      B: "Sếp rủ xuống sảnh uống ly cafe sữa đá, hỏi han sức khỏe.",
      C: "Đồng nghiệp xúm vào dọn hộ đống giấy tờ trên bàn để bạn về sớm.",
      D: "Ai đó dúi cho ly trà sữa full topping.",
      E: "Cả team vỗ tay rào rào, đập tay 'high-five' ăn mừng."
    }
  },
  {
    id: 2,
    text: "2. Sáng thứ Hai đến công ty mà người mệt lả, điều gì làm bạn tỉnh hẳn?",
    options: {
      A: "Có người bảo: 'Cố lên, team mình không ai làm tốt vụ này bằng bà đâu.'",
      B: "Đồng nghiệp kéo ra góc pantry chém gió 10 phút cho xả stress.",
      C: "Đứa ngồi cạnh bảo: 'Đưa bớt cái báo cáo đây tui nhập số liệu cho.'",
      D: "Thấy trên bàn có sẵn ổ bánh mì thịt nướng khoái khẩu.",
      E: "Đồng nghiệp vỗ vai một cái rõ kêu: 'Lên tinh thần nào anh em!'"
    }
  },
  {
    id: 3,
    text: "3. Công ty muốn thưởng nóng cho bạn vì 'gánh team' tháng qua. Bạn thích:",
    options: {
      A: "Được tuyên dương và trao bằng khen trước toàn công ty.",
      B: "Được đi ăn trưa riêng với sếp tổng để chia sẻ định hướng.",
      C: "Được cấp thêm một bạn thực tập sinh để hỗ trợ việc vặt.",
      D: "Được tặng một voucher đi spa mát-xa xịn xò.",
      E: "Được sếp bước tới bắt tay thật chặt trước mặt mọi người."
    }
  },
  {
    id: 4,
    text: "4. Khi bạn làm sai một việc rắc rối, bạn muốn đồng nghiệp phản ứng thế nào?",
    options: {
      A: "Nói nhẹ nhàng: 'Không sao, sai thì sửa, mọi người hiểu mà.'",
      B: "Ngồi lại cùng bạn 15 phút để nghe bạn giải thích nguyên nhân.",
      C: "Nhảy vào phụ bạn đi xin lỗi khách hàng và gỡ rối.",
      D: "Mua cho bạn một món ăn vặt để bạn đỡ buồn miệng.",
      E: "Khoác vai an ủi: 'Chuyện nhỏ, xõa đi.'"
    }
  },
  {
    id: 5,
    text: "5. Sắp đến sinh nhật bạn, bạn mong chờ điều gì ở văn phòng?",
    options: {
      A: "Mọi người viết những lời chúc siêu có tâm lên một tấm thiệp.",
      B: "Cả nhóm bỏ ra 30 phút buổi chiều ngồi quây quần ăn bánh kem, nói chuyện phiếm.",
      C: "Mọi người tự giác chia nhau làm đỡ phần việc của bạn trong ngày hôm đó.",
      D: "Được tặng một món quà đúng cái món bạn đang ao ước.",
      E: "Những cái ôm ấm áp hoặc những cú đụng tay chúc mừng từ anh em."
    }
  },
  {
    id: 6,
    text: "6. Một dự án bị tắc nghẽn dài ngày, cuối cùng cũng xong. Đội nhóm nên:",
    options: {
      A: "Viết email cảm ơn sự cống hiến của từng người.",
      B: "Tổ chức một buổi đi nhậu/ăn ốc sau giờ làm để gắn kết.",
      C: "Cho mọi người nghỉ nửa ngày để dọn dẹp lại máy tính, chỗ ngồi.",
      D: "Tặng mỗi người một hộp quà nhỏ mang về cho gia đình.",
      E: "Cả phòng đứng lên reo hò, khoác vai nhau chụp hình tập thể."
    }
  },
  {
    id: 7,
    text: "7. Nếu phải chọn một điều để giữ bạn ở lại công ty lâu dài:",
    options: {
      A: "Sếp luôn công nhận và khen thưởng những gì tôi đóng góp.",
      B: "Sếp luôn dành thời gian lắng nghe ý kiến của tôi.",
      C: "Mọi người làm việc nhóm cực tốt, luôn sẵn sàng nhảy vào cứu net nhau.",
      D: "Công ty hay có những phúc lợi, quà cáp bất ngờ, lễ tết chu đáo.",
      E: "Môi trường tràn đầy năng lượng, anh em thân thiết như người nhà."
    }
  },
  {
    id: 8,
    text: "8. Bạn đang thuyết trình một ý tưởng mới. Điều gì làm bạn tự tin nhất?",
    options: {
      A: "Sếp gật gù bảo: 'Ý tưởng này sáng tạo đấy.'",
      B: "Mọi người bỏ điện thoại xuống và nhìn thẳng vào bạn lắng nghe.",
      C: "Có đồng nghiệp đứng lên giúp bạn ghi chú ý chính lên bảng.",
      D: "Sếp thưởng nóng một món quà nhỏ vì ý tưởng hay.",
      E: "Lúc bước xuống, đồng nghiệp đập tay chúc mừng màn trình diễn tốt."
    }
  },
  {
    id: 9,
    text: "9. Cách bạn thường dùng để thể hiện sự quý mến với đồng nghiệp là:",
    options: {
      A: "Thường xuyên khen ngợi họ.",
      B: "Hay rủ họ đi ăn trưa, cà phê.",
      C: "Thấy họ bận là bay vào làm phụ.",
      D: "Đi đâu chơi cũng nhớ mua đặc sản về cho họ.",
      E: "Hay huých tay, vỗ vai, tạo không khí vui vẻ."
    }
  },
  {
    id: 10,
    text: "10. Một đồng nghiệp mới vào làm và trông có vẻ lạc lõng. Bạn sẽ:",
    options: {
      A: "Ra chào hỏi và nói: 'Trông bạn có vẻ hợp với team tụi mình đấy!'",
      B: "Dành trọn giờ nghỉ trưa để ngồi ăn cùng và dẫn họ đi dạo công ty.",
      C: "Cài đặt hộ họ máy in, các phần mềm và hướng dẫn quy trình.",
      D: "Đưa cho họ một ly nước và một vài viên kẹo.",
      E: "Vui vẻ bắt tay và vỗ vai chào mừng họ gia nhập đội."
    }
  },
  {
    id: 11,
    text: "11. Cuối năm đánh giá KPI, phần nào làm bạn hồi hộp mong đợi nhất?",
    options: {
      A: "Những lời nhận xét chi tiết về điểm mạnh của mình.",
      B: "Trực tiếp ngồi nói chuyện 1-1 với sếp về tương lai.",
      C: "Nhìn thấy công ty có những hành động cụ thể hỗ trợ phòng ban của mình.",
      D: "Xem năm nay quà Tết và tiền thưởng có gì hot.",
      E: "Cảm giác cái bắt tay ấm áp của sếp khi chốt lại một năm nỗ lực."
    }
  },
  {
    id: 12,
    text: "12. Bạn thấy khó chịu nhất ở chỗ làm khi:",
    options: {
      A: "Làm tốt mà chẳng ai nói một lời nào.",
      B: "Đang nói chuyện mà người kia cứ bấm điện thoại, lơ đãng.",
      C: "Mình ngập đầu trong việc mà người khác cứ ngồi chơi không giúp.",
      D: "Lễ tết mà công ty chẳng có lấy một món quà nhỏ động viên.",
      E: "Không khí văn phòng lạnh lẽo, ai biết việc nấy, không chạm mặt nhau."
    }
  },
  {
    id: 13,
    text: "13. Làm việc online (Work from home), bạn nhớ điều gì nhất ở công ty?",
    options: {
      A: "Cảm giác được chat nhóm tung hô nhau.",
      B: "Những lúc ngồi tán dóc trực tiếp ngoài ban công.",
      C: "Lúc máy tính hỏng có IT chạy lại sửa liền.",
      D: "Những bữa chia nhau bịch bánh tráng trộn, ly chè.",
      E: "Không khí nhộn nhịp, vỗ vai đập bàn lúc trúng mánh."
    }
  },
  {
    id: 14,
    text: "14. Sếp chuẩn bị chuyển công tác, bạn muốn sếp để lại gì cho bạn?",
    options: {
      A: "Một bức thư tay ghi nhận sự đóng góp của bạn.",
      B: "Một buổi cafe riêng để sếp truyền đạt lại kinh nghiệm.",
      C: "Sếp dọn dẹp sạch sẽ các quy trình lằng nhằng trước khi đi để bạn nhẹ gánh.",
      D: "Sếp tặng lại bạn cuốn sách hay đồ vật trên bàn sếp mà bạn thích.",
      E: "Một cái ôm chân tình chào tạm biệt."
    }
  },
  {
    id: 15,
    text: "15. Khi bạn cảm thấy mất động lực (burnout), 'liều thuốc' nào hiệu quả nhất?",
    options: {
      A: "Lời khẳng định: 'Công ty thực sự cần bạn.'",
      B: "Sếp cho một buổi không làm việc, chỉ để ngồi lắng nghe bạn xả cục tức.",
      C: "Team giãn bớt deadline cho bạn thở.",
      D: "Nhận được một hộp đồ ăn ngon giao tận bàn.",
      E: "Anh em xúm lại khoác vai động viên, kéo ra ngoài hít thở."
    }
  }
];

const resultsData = {
  A: { title: "LỜI KHEN NGỢI 💬", desc: "Ngôn ngữ của bạn là Lời Khen. Bạn thích được công nhận, khen thưởng rõ ràng và cực kỳ có động lực khi biết sếp và anh em ghi nhận công sức của mình." },
  B: { title: "THỜI GIAN CHẤT LƯỢNG ☕", desc: "Ngôn ngữ của bạn là Thời Gian. Bạn trân trọng những người chịu cất điện thoại đi, thực sự lắng nghe và dành thời gian uống ly cafe, tâm sự công việc với bạn." },
  C: { title: "HÀNH ĐỘNG GIÚP ĐỠ 🤝", desc: "Ngôn ngữ của bạn là Giúp Đỡ. Bạn ghét nói suông! Thấy bạn ngập mặt trong deadline mà bay vào làm phụ thì đó mới là chân ái." },
  D: { title: "QUÀ TẶNG NHỎ 🎁", desc: "Ngôn ngữ của bạn là Quà Tặng. Không cần đồ đắt tiền, chỉ cần ly trà sữa hay bịch bánh tráng lúc mệt mỏi cũng đủ cho thấy anh em có nhớ tới bạn." },
  E: { title: "CỬ CHỈ ĐỘNG VIÊN ✋", desc: "Ngôn ngữ của bạn là Cử Chỉ. Bạn thích không khí năng động, những cú đập tay high-five, cái khoác vai an ủi hay cái bắt tay ăn mừng dự án." }
};

export default function AppreciationQuiz() {
  const [answers, setAnswers] = useState({});
  const [result, setResult] = useState(null);

  const handleSelect = (questionId, optionKey) => {
    setAnswers({ ...answers, [questionId]: optionKey });
  };

  const calculateResult = () => {
    // Check if all questions are answered
    if (Object.keys(answers).length < questions.length) {
      alert("Bạn ơi, trả lời hết các câu hỏi rồi mới xem kết quả được nhé!");
      return;
    }

    // Tally the scores
    const counts = { A: 0, B: 0, C: 0, D: 0, E: 0 };
    Object.values(answers).forEach((ans) => {
      counts[ans]++;
    });

    // Find the highest score
    let highestScore = 0;
    let winningLanguage = "A";

    for (const [key, value] of Object.entries(counts)) {
      if (value > highestScore) {
        highestScore = value;
        winningLanguage = key;
      }
    }

    setResult(resultsData[winningLanguage]);
  };

  return (
    <div style={{ maxWidth: "600px", margin: "0 auto", padding: "20px", fontFamily: "sans-serif" }}>
      <h1 style={{ textAlign: "center", color: "#333" }}>Khám Phá "Ngôn Ngữ Ghi Nhận" Chốn Công Sở! 🚀</h1>
      
      <div style={{ backgroundColor: "#fff3cd", padding: "20px", borderRadius: "8px", borderLeft: "5px solid #ffc107", marginBottom: "30px", color: "#664d03" }}>
        <p style={{ margin: "0 0 10px 0", fontWeight: "bold", fontSize: "16px" }}>💡 Bạn có biết?</p>
        <p style={{ margin: "0", lineHeight: "1.5", fontSize: "15px" }}>
          Bạn có bao giờ thắc mắc vì sao sếp bao trà sữa mà team vẫn ỉu xìu, nhưng đôi khi chỉ một câu khen đúng lúc lại làm anh em cày hăng say? Theo chuyên gia Gary Chapman, mỗi người đều có một <strong>"Ngôn Ngữ Ghi Nhận" (Language of Appreciation)</strong> riêng. Hiểu nôm na là "gu" nhận sự quan tâm.
        </p>
        
        <div style={{ marginTop: "20px", padding: "15px", backgroundColor: "#ffffff", borderRadius: "8px", border: "1px dashed #ffc107" }}>
          <p style={{ margin: "0 0 10px 0", fontWeight: "bold", fontSize: "15px", color: "#333" }}>📚 Lộ Trình "Tu Luyện" Cho Team:</p>
          <ul style={{ margin: "0", paddingLeft: "20px", fontSize: "15px", lineHeight: "1.8", color: "#333" }}>
            <li>
              <strong>Bước 1:</strong> Xem Video tóm tắt siêu dính <a href="https://notebooklm.google.com/notebook/907c6d8f-a754-4258-a081-2395ce4ef770?artifactId=1147dac6-39e1-4f31-a173-10c1be6d881b" target="_blank" rel="noreferrer" style={{ color: "#007BFF", textDecoration: "none", fontWeight: "bold" }}>[Xem Tại Đây]</a>
            </li>
            <li>
              <strong>Bước 2:</strong> Nghe Podcast chém gió về chủ đề này <a href="https://notebooklm.google.com/notebook/907c6d8f-a754-4258-a081-2395ce4ef770?artifactId=96e033c4-1b92-40fc-9833-4df8666f5c7e" target="_blank" rel="noreferrer" style={{ color: "#007BFF", textDecoration: "none", fontWeight: "bold" }}>[Nghe Tại Đây]</a>
            </li>
            <li>
              <strong>Bước 3:</strong> Làm bài Trắc nghiệm bản thân (ngay bên dưới 👇)
            </li>
            <li>
              <strong>Bước 4:</strong> Làm bài Kiểm tra kiến thức (Knowledge Assessment) <a href="/kiem-tra-tinh-te" style={{ color: "#007BFF", textDecoration: "none", fontWeight: "bold" }}>[Test Tại Đây]</a>
            </li>
          </ul>
        </div>
      </div>

      {!result ? (
        <div>
          {questions.map((q) => (
            <div key={q.id} style={{ marginBottom: "25px", padding: "15px", border: "1px solid #ddd", borderRadius: "8px", backgroundColor: "#f9f9f9" }}>
              <p style={{ fontWeight: "bold", marginTop: "0" }}>{q.text}</p>
              <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                {Object.entries(q.options).map(([key, text]) => (
                  <label key={key} style={{ cursor: "pointer", display: "flex", alignItems: "center", gap: "10px" }}>
                    <input
                      type="radio"
                      name={`question-${q.id}`}
                      value={key}
                      checked={answers[q.id] === key}
                      onChange={() => handleSelect(q.id, key)}
                      style={{ width: "20px", height: "20px" }}
                    />
                    {text}
                  </label>
                ))}
              </div>
            </div>
          ))}

          <button 
            onClick={calculateResult} 
            style={{ width: "100%", padding: "15px", fontSize: "18px", backgroundColor: "#007BFF", color: "white", border: "none", borderRadius: "8px", cursor: "pointer", fontWeight: "bold" }}
          >
            Gửi Bài & Xem Kết Quả Ngay!
          </button>
        </div>
      ) : (
        <div style={{ textAlign: "center", padding: "30px", border: "2px solid #007BFF", borderRadius: "10px", backgroundColor: "#e6f2ff" }}>
          <h2>Kết Quả Của Bạn:</h2>
          <h1 style={{ color: "#007BFF", fontSize: "28px" }}>{result.title}</h1>
          <p style={{ fontSize: "18px", lineHeight: "1.6" }}>{result.desc}</p>
          <button 
            onClick={() => { setResult(null); setAnswers({}); }} 
            style={{ marginTop: "20px", padding: "10px 20px", backgroundColor: "#333", color: "white", border: "none", borderRadius: "5px", cursor: "pointer" }}
          >
            Làm lại bài test
          </button>
          <p style={{ marginTop: "20px", fontWeight: "bold", color: "#d9534f" }}>
            👉 Chụp màn hình này ném vào group Zalo để anh em biết đường mà chiều nhé!
          </p>
        </div>
      )}
    </div>
  );
}